var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 40.4l2.5-9.9L27 15.6l7.4 7.4-14.9 14.9-9.9 2.5zm4.3-8.9l-1.5 6.1 6.1-1.5L31.6 23 27 18.4 13.9 31.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 37.3c-.6-2.5-2.6-4.5-5.1-5.1l.5-1.9c3.2.8 5.7 3.3 6.5 6.5l-1.9.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.298 19.287l1.414 1.414-13.01 13.02-1.414-1.412z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39l2.9-.7c-.3-1.1-1.1-1.9-2.2-2.2L11 39z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22.4L27.6 15l3-3 .5.1c3.6.5 6.4 3.3 6.9 6.9l.1.5-3.1 2.9zM30.4 15l4.6 4.6.9-.9c-.5-2.3-2.3-4.1-4.6-4.6l-.9.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenIcon);
export default __webpack_public_path__ + "static/media/edit-pen-icon.95b0217617523c13131aeae03316ec75.svg";
export { ForwardRef as ReactComponent };